export default {
  pageTitle: "Help & Support",
  pageDescription: "Find answers or submit a support request",
  myTickets: "My Tickets",
  sections: {
    faqTitle: "Frequently Asked Questions",
    faqDescription: "Browse common questions about the platform",
    ticketTitle: "Submit a Support Ticket",
    ticketDescription:
      "Describe your issue and our team will get back to you by email",
  },
  needHelp: {
    title: "Didn't find what you're looking for?",
    description:
      "Our support team is ready to help. Submit a ticket and we'll respond as soon as possible.",
    action: "Submit a Ticket",
  },
  tabs: {
    faq: "FAQ",
    faqDesc: "Find answers to common questions",
    ticket: "Submit Ticket",
    ticketDesc: "Report issues or request help",
  },
  faqSearchPlaceholder: "Search questions and answers",
  faqAll: "All",
  faqNone: "No FAQs found for this category",
  ticketForm: {
    requestTypeLabel: "What type of request is this?",
    requestTypeHint: "Select the option that best describes your request",
    priorityLabel: "Priority",
    priorityHint: "How urgent is this issue for your business?",
    subjectLabel: "Subject",
    subjectPlaceholder: "Brief description of your issue",
    messageLabel: "Message",
    messagePlaceholder: "Describe your issue in detail...",
    attachmentsLabel: "Attachments",
    attachmentsHint: "Drop files here or click to upload (max 20 MB each)",
    addFiles: "Add files",
    submit: "Submit Ticket",
    fileTooLarge: "{{name}} is too large. Max size is {{max}}.",
    fileUnsupported: "{{name}} is not a supported file type.",
    toastSelectCategory: "Please select a category",
    toastEnterSubject: "Please enter a subject",
    toastEnterMessage: "Please enter a message",
    toastSubmitted: "Ticket submitted! We'll get back to you soon.",
    toastSubmitFailed: "Failed to submit ticket. Please try again.",
    toastAttachmentsFailed:
      "Ticket created, but the attachments could not be uploaded. You can add them from the ticket page.",
    categories: {
      problem: "Problem",
      suggestion: "Suggestion",
      improvement: "Improvement",
      question: "Question",
      billing: "Billing",
    },
    priorities: {
      critical: "Critical",
      high: "High",
      medium: "Medium",
      normal: "Normal",
      low: "Low",
    },
    respondLine: "We'll respond to {{email}}",
  },
  list: {
    title: "My Tickets",
    description: "View and manage your support requests",
    backToSupport: "Help & Support",
    newTicket: "New Ticket",
    createTicket: "Create Ticket",
    searchPlaceholder: "Search tickets by subject or number...",
    loadingTickets: "Loading tickets...",
    loadError: "Failed to load tickets",
    noTicketsFound: "No tickets found",
    tryAdjusting: "Try adjusting your search or filter",
    createFirstHint: "Create your first ticket to get help",
    lastActivityShort: "Last: {{when}}",
    replyNeeded: "Reply needed",
    messageCountPlain: "{{count}}",
    stats: {
      ongoing: "Active",
      filterLabel: "Ticket status",
      total: "All",
    },
  },
  adminList: {
    searchPlaceholder: "Search by ticket number, subject, or seller...",
    filterAny: "Any",
    priority: "Priority",
    category: "Category",
    ticketsFound_one: "{{count}} ticket found",
    ticketsFound_other: "{{count}} tickets found",
    loadingTickets: "Loading tickets...",
    noTicketsFound: "No tickets found",
    tryAdjusting: "Try adjusting your filters",
    allCaughtUp: "All caught up!",
    clearFilters: "Clear filters",
  },
  sidebar: {
    seller: "Seller",
    unknownSeller: "Unknown Seller",
    sendEmail: "Send Email",
    openProfile: "Open profile",
    statusAndPriority: "Status & Priority",
    status: "Status",
    priority: "Priority",
    details: "Details",
    category: "Category",
    created: "Created",
    lastUpdated: "Last Updated",
    resolved: "Resolved",
    messages: "Messages",
    messagesTotal: "{{count}} total",
    quickActions: "Quick Actions",
    markAsResolved: "Mark as Resolved",
    closeTicket: "Close Ticket",
    reopenTicket: "Reopen Ticket",
  },
  adminDetail: {
    loadingTicket: "Loading ticket...",
    notFound: "Ticket not found",
    backToTickets: "Back to Tickets",
    ticketDetails: "Ticket Details",
    openedOn: "Opened {{date}}",
    messagesCount: "{{count}} messages",
    replyPlaceholder: "Type your reply (email will be sent to seller)...",
    ticketClosed: "This ticket is closed.",
    reopenTicket: "Reopen ticket",
  },
  messageInput: {
    modeLabel: "Message type",
    defaultPlaceholder: "Type your message...",
    internalNotePlaceholder: "Add an internal note...",
    replyToPartner: "Reply to Seller",
    internalNote: "Internal Note",
    internalNoteWarning: "Internal notes are only visible to staff",
    attach: "Attach",
    fileTooLarge: "{{name}} is too large. Max size is {{max}}.",
    fileUnsupported: "{{name}} is not a supported file type.",
    addNote: "Add Note",
    send: "Send",
  },
  messageBubble: {
    internalNote: "Internal Note",
    supportTeam: "Support Team",
    you: "You",
    sellerFallback: "Seller",
  },
  detail: {
    messageSent: "Message sent!",
    sendMessageError: "Failed to send message",
    loadingTicket: "Loading ticket...",
    notFound: "Ticket not found",
    backToTickets: "Back to Tickets",
    conversationEmpty: "No messages yet. Start the conversation below.",
    messagesCount_one: "{{count}} message",
    messagesCount_other: "{{count}} messages",
    messagePlaceholder: "Type your message...",
    resolvedTitle: "This ticket has been resolved",
    resolvedNeedHelp: "Need more help?",
    openNewTicket: "Open a new ticket",
    openedOn: "Opened {{date}}",
    replyNeededTitle: "The support team replied",
    replyNeededDescription:
      "Read the latest message below and send your reply to keep the ticket open.",
  },
  adminHub: {
    ticketsTab: "Support Tickets",
    ticketsDescription: "Manage partner support tickets",
    chatsTab: "Customer Support Chats",
    chatsDescription: "Manage customer support chats",
  },
  customerSupportChats: {
    searchPlaceholder: "Search by contact…",
    loading: "Loading chats…",
    loadingChat: "Loading conversation…",
    empty: "No customer support chats match this filter",
    emptyOpen: "No open customer support chats",
    statusFilter: "Status",
    filterOpen: "Open",
    filterClosed: "Closed",
    filterAll: "All",
    closedBadge: "Closed",
    selectChat: "Select a chat to view the conversation",
    noMessages: "No messages yet",
    guest: "Guest",
    registeredCustomer: "Registered customer",
    replyPlaceholder: "Reply to the customer…",
    chatClosed: "This chat is closed.",
    closeChat: "Close chat",
    closed: "Chat closed",
    recentBookings: "Recent bookings",
    noBookings: "No bookings found for this contact",
    lastHandshakeBadge: "Last handshake",
    openBooking: "Open",
    amend: "Amend",
    reopenHandshake: "Reopen handshake",
    cancelBooking: "Cancel",
    amendTitle: "Amend booking date/time",
    visitDateLabel: "Visit date",
    visitTimeLabel: "Visit time",
    overrideCapacity: "Override capacity/deadline warnings",
    amendConfirm: "Save amendment",
    amendSuccess: "Booking amended",
    cancelTitle: "Cancel booking",
    cancelDescriptionWithDetails:
      "Cancel the booking for {{name}} ({{activity}})? Confirm amount on the booking detail if needed. Refunds start automatically and cannot be undone.",
    refundChoiceLabel: "Refund policy",
    refundDefault: "Refund if inside window, otherwise no refund",
    refundForce: "Always refund",
    refundNone: "Never refund (settle as fulfilled if paid)",
    cancelConfirm: "Confirm cancellation",
    cancelSuccess: "Booking cancelled",
    reopenSuccess: "Handshake reopened; this chat was closed",
    reopenConfirmTitle: "Reopen handshake?",
    reopenConfirmMessage:
      "This will close the support chat and reopen the handshake so the partner can amend the booking in chat.",
    reopenConfirm: "Reopen handshake",
    cancelForceConfirmTitle: "Confirm override cancellation?",
    cancelForceRefundMessage:
      "You chose to always refund. This overrides the refund-window policy and cannot be undone from this screen.",
    cancelForceNoneMessage:
      "You chose never to refund. Paid bookings may settle as fulfilled with no customer refund.",
  },
} as const;
